define('tagmanager/tmshelpers',[
    'domhelpers'
], function(domHelpers) {
    'use strict';

    var ensightenTestName = 'edapFeatureLoadEnsighten',
        bootstrapperUrlMapping = {
            bnb: {
                'unit': '//nexus.ensighten.com/away/bnb-test/Bootstrap.js',
                'dev': '//nexus.ensighten.com/away/bnb-test/Bootstrap.js',
                'test': '//nexus.ensighten.com/away/bnb-test/Bootstrap.js',
                'stage': '//nexus.ensighten.com/away/bnb-stage/Bootstrap.js',
                'production': '//nexus.ensighten.com/away/bnb-production/Bootstrap.js'
            },
            stayz: {
                'unit': '//nexus.ensighten.com/away/stayz-test/Bootstrap.js',
                'dev': '//nexus.ensighten.com/away/stayz-test/Bootstrap.js',
                'test': '//nexus.ensighten.com/away/stayz-test/Bootstrap.js',
                'stage': '//nexus.ensighten.com/away/stayz-stage/Bootstrap.js',
                'production': '//nexus.ensighten.com/away/stayz-production/Bootstrap.js'
            },
            toprural: {
                'unit': '//nexus.ensighten.com/away/toprural-test/Bootstrap.js',
                'dev': '//nexus.ensighten.com/away/toprural-test/Bootstrap.js',
                'test': '//nexus.ensighten.com/away/toprural-test/Bootstrap.js',
                'stage': '//nexus.ensighten.com/away/toprural-stage/Bootstrap.js',
                'production': '//nexus.ensighten.com/away/toprural-production/Bootstrap.js'
            },
            'default': {
                'unit': '//nexus.ensighten.com/away/test/Bootstrap.js',
                'dev': '//nexus.ensighten.com/away/test/Bootstrap.js',
                'test': '//nexus.ensighten.com/away/test/Bootstrap.js',
                'stage': '//nexus.ensighten.com/away/stage/Bootstrap.js',
                'production': '//nexus.ensighten.com/away/production/Bootstrap.js'
            }
        },
        myEdap;

    return {
        /**
         * Simple getter for tagmanager EDAP Scope
         *
         * @return {Object} tagmanager EDAP scope
         */
        getEdapScope: function() {
            return myEdap;
        },

        /**
         * Simple setter for tagmanager EDAP Scope
         *
         * @param  {Object} edapInstance New value for tagmanager EDAP scope
         */
        setEdapScope: function(edapInstance) {
            myEdap = edapInstance;
        },

        /**
         * Initialize tag manager tools
         *
         * @param  {Object} edapInstance The tagmanager integration's EDAP Scope
         */
        init: function(edapInstance) {
            var that = this;

            that.setEdapScope(edapInstance);

            that.initEnsighten();
        },

        /**
         * Sets up necessary edap on() handler for loading the appropriate bootstrapper
         */
        initEnsighten: function() {
            var that = this;

            myEdap.once('tagmanager.load', function(data) {
                myEdap['public'].features.onLoad(function() {
                    var ensightenEnabled = myEdap['public'].features.getFeatureProperty(ensightenTestName, 'value') === 'on';

                    if (ensightenEnabled) {
                        that.loadEnsighten(data.monikerbrand, data.appenvironment);
                    }
                });
            });
        },

        /**
         * Loads the appropriate Ensighten bootstrapper
         *
         * @param  {String} monikerbrand   The monikerbrand to load the bootstrapper for
         * @param  {String} appenvironment The app environment to load a bootstrapper for
         */
        loadEnsighten: function(monikerbrand, appenvironment) {
            var that = this,
                bootstrapperUrl = that.getBootstrapperUrl(monikerbrand, appenvironment),
                currentTimestamp = domHelpers.getMsFromEpoch();

            // getBootstrapperUrl is guaranteed to return a valid URL
            domHelpers.loadScript(bootstrapperUrl);

            // store current timestamp into scope data so we can check how long loading took
            myEdap.getData().loadtimestamp = currentTimestamp;
        },

        /**
         * Gets the appropriate bootstrapper URL for the given app environment
         * Will always return a valid URL - if appenvironment is invalid, defaults to 'production'
         *
         * @param  {String} monikerbrand   The monikerbrand to load the bootstrapper for
         * @param  {String} appenvironment The app environment to retrieve a bootstrapper URL for
         * @return {String}                The URL for appenvironment
         */
        getBootstrapperUrl: function(monikerbrand, appenvironment) {
            var brandLookup = 'default',
                env;

            // If the monikerbrand starts with bnb then it is one of the bnb brands
            if (monikerbrand && (monikerbrand.indexOf('bnb') === 0)) {
                brandLookup = 'bnb';
            } else if (bootstrapperUrlMapping.hasOwnProperty(monikerbrand)) {
                brandLookup = monikerbrand;
            }

            // Figure out which Bootstrapper is appropriate
            if (bootstrapperUrlMapping[brandLookup][appenvironment] !== undefined) {
                env = appenvironment;
            } else {
                // default to production URL
                env = 'production';
            }

            return bootstrapperUrlMapping[brandLookup][env];
        }
    };
});

